import { BaseApiModel } from './BaseApiModel';

export class FileTemplate extends BaseApiModel {
  public contractId: string;
  public type: string;
  public body: string;
  public createdAt: string;
  public modifiedAt: string;
  public deletedAt: string;
}
